import DatePicker from "primevue/datepicker";
import { correggiDatePicker } from "~/utils/datePickerOrario.js";

// I plugin girano prima del montaggio dell'app, quindi prima di qualsiasi DatePicker: la
// correzione vale per tutti, senza toccare le pagine (v. utils/datePickerOrario.js).
export default defineNuxtPlugin(() => {
  correggiDatePicker(DatePicker);
});
